import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=0ea91d18&scoped=true&"
import script from "./Edition.vue?vue&type=script&lang=js&"
export * from "./Edition.vue?vue&type=script&lang=js&"
import style0 from "./Edition.vue?vue&type=style&index=0&id=0ea91d18&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea91d18",
  null
  
)

export default component.exports